
// user groups
export const ADMIN_GROUP = 'Admin';
export const CAMPAIGN_DIRECTOR = 'Campaign Director';
export const CAMPAIGN_MANAGER = 'Campaign Manager';
export const CLIENT_GROUP = 'Client';

export const CAN_SEE_COVERAGE = {
  action: 'see',
  subject: 'Coverage',
};

export const CAN_SEE_ROTTING = {
  action: 'see',
  subject: 'Rotting',
};

export const ROLE_PERMISSIONS = {
  [ADMIN_GROUP]: [
    {
      action: 'see',
      subject: 'Campaign',
    },
    {
      action: 'copy',
      subject: 'Campaign',
    },
    {
      action: 'copy',
      subject: 'Sequence',
    },
    {
      action: 'see',
      subject: 'Account',
    },
    {
      action: 'see',
      subject: 'Sequence',
    },
    CAN_SEE_COVERAGE,
    {
      action: 'edit',
      subject: 'Coverage',
    },
    {
      action: 'create',
      subject: 'Sequence',
    },
    {
      action: 'create',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Inbox',
    },
    {
      action: 'see',
      subject: 'Campaign Inbox',
    },
    {
      action: 'create',
      subject: 'Pitch',
    },
    {
      action: 'create',
      subject: 'Step',
    },
    {
      action: 'edit',
      subject: 'Step',
    },
    {
      action: 'delete',
      subject: 'Step',
    },
    {
      action: 'edit',
      subject: 'Step Delay',
    },
    {
      action: 'delete',
      subject: 'Sequence',
    },
    {
      action: 'edit',
      subject: 'Sequence Contact',
    },
    {
      action: 'toggle',
      subject: 'Sequence',
    },
    {
      action: 'toggle',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Contact Email',
    },
    {
      action: 'see',
      subject: 'Manager',
    },
    {
      action: 'edit',
      subject: 'Default Schedule',
    },
    {
      action: 'filterBy',
      subject: 'Manager',
    },
    {
      action: 'filterBy',
      subject: 'Campaign',
    },
    {
      action: 'filterBy',
      subject: 'Account',
    },
    {
      action: 'filterBy',
      subject: 'Sequence',
    },
    {
      action: 'see',
      subject: 'Campaign Settings',
    },
    {
      action: 'add',
      subject: 'Contact',
    },
    {
      action: 'see',
      subject: 'Sequence Settings',
    },
    {
      action: 'edit',
      subject: 'Sequence  label',
    },
    {
      action: 'edit',
      subject: 'Campaign  label',
    },
    {
      action: 'delete',
      subject: 'Message',
    },
    {
      action: 'reply',
      subject: 'Message',
    },
    {
      action: 'changeStatus',
      subject: 'Message',
    },
    {
      action: 'markAsUnread',
      subject: 'Message',
    },
    {
      action: 'markAsRead',
      subject: 'Message',
    },
    {
      action: 'markAsReadBulk',
      subject: 'Message',
    },
    {
      action: 'archive',
      subject: 'Message',
    },
    {
      action: 'delete',
      subject: 'Message',
    },
    {
      action: 'select',
      subject: 'Message',
    },
    {
      action: 'see',
      subject: 'Bounced rate',
    },
    CAN_SEE_ROTTING,
  ],
  [CAMPAIGN_DIRECTOR]: [
    {
      action: 'see',
      subject: 'Campaign',
    },
    {
      action: 'copy',
      subject: 'Campaign',
    },
    {
      action: 'copy',
      subject: 'Sequence',
    },
    {
      action: 'see',
      subject: 'Account',
    },
    {
      action: 'see',
      subject: 'Sequence',
    },
    CAN_SEE_COVERAGE,
    {
      action: 'edit',
      subject: 'Coverage',
    },
    {
      action: 'create',
      subject: 'Sequence',
    },
    {
      action: 'create',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Inbox',
    },
    {
      action: 'see',
      subject: 'Campaign Inbox',
    },
    {
      action: 'create',
      subject: 'Pitch',
    },
    {
      action: 'create',
      subject: 'Step',
    },
    {
      action: 'edit',
      subject: 'Step',
    },
    {
      action: 'delete',
      subject: 'Step',
    },
    {
      action: 'edit',
      subject: 'Step Delay',
    },
    {
      action: 'delete',
      subject: 'Sequence',
    },
    {
      action: 'edit',
      subject: 'Sequence Contact',
    },
    {
      action: 'toggle',
      subject: 'Sequence',
    },
    {
      action: 'toggle',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Contact Email',
    },
    {
      action: 'see',
      subject: 'Manager',
    },
    {
      action: 'filterBy',
      subject: 'Manager',
    },
    {
      action: 'filterBy',
      subject: 'Campaign',
    },
    {
      action: 'filterBy',
      subject: 'Account',
    },
    {
      action: 'filterBy',
      subject: 'Sequence',
    },
    {
      action: 'see',
      subject: 'Campaign Settings',
    },
    {
      action: 'add',
      subject: 'Contact',
    },
    {
      action: 'see',
      subject: 'Sequence Settings',
    },
    {
      action: 'edit',
      subject: 'Sequence  label',
    },
    {
      action: 'edit',
      subject: 'Campaign  label',
    },
    {
      action: 'delete',
      subject: 'Message',
    },
    {
      action: 'reply',
      subject: 'Message',
    },
    {
      action: 'changeStatus',
      subject: 'Message',
    },
    {
      action: 'markAsUnread',
      subject: 'Message',
    },
    {
      action: 'markAsRead',
      subject: 'Message',
    },
    {
      action: 'markAsReadBulk',
      subject: 'Message',
    },
    {
      action: 'archive',
      subject: 'Message',
    },
    {
      action: 'delete',
      subject: 'Message',
    },
    {
      action: 'select',
      subject: 'Message',
    },
    {
      action: 'see',
      subject: 'Bounced rate',
    },
    CAN_SEE_ROTTING,
  ],
  [CAMPAIGN_MANAGER]: [
    {
      action: 'see',
      subject: 'Campaign',
    },
    {
      action: 'copy',
      subject: 'Campaign',
    },
    {
      action: 'copy',
      subject: 'Sequence',
    },
    {
      action: 'see',
      subject: 'Account',
    },
    {
      action: 'see',
      subject: 'Sequence',
    },
    CAN_SEE_COVERAGE,
    {
      action: 'edit',
      subject: 'Coverage',
    },
    {
      action: 'create',
      subject: 'Sequence',
    },
    {
      action: 'create',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Inbox',
    },
    {
      action: 'see',
      subject: 'Campaign Inbox',
    },
    {
      action: 'create',
      subject: 'Pitch',
    },
    {
      action: 'create',
      subject: 'Step',
    },
    {
      action: 'edit',
      subject: 'Step',
    },
    {
      action: 'delete',
      subject: 'Step',
    },
    {
      action: 'edit',
      subject: 'Step Delay',
    },
    {
      action: 'delete',
      subject: 'Sequence',
    },
    {
      action: 'edit',
      subject: 'Sequence Contact',
    },
    {
      action: 'toggle',
      subject: 'Sequence',
    },
    {
      action: 'toggle',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Contact Email',
    },
    {
      action: 'filterBy',
      subject: 'Campaign',
    },
    {
      action: 'filterBy',
      subject: 'Account',
    },
    {
      action: 'filterBy',
      subject: 'Sequence',
    },
    {
      action: 'see',
      subject: 'Campaign Settings',
    },
    {
      action: 'add',
      subject: 'Contact',
    },
    {
      action: 'see',
      subject: 'Sequence Settings',
    },
    {
      action: 'edit',
      subject: 'Sequence  label',
    },
    {
      action: 'edit',
      subject: 'Campaign  label',
    },
    {
      action: 'delete',
      subject: 'Message',
    },
    {
      action: 'reply',
      subject: 'Message',
    },
    {
      action: 'changeStatus',
      subject: 'Message',
    },
    {
      action: 'markAsUnread',
      subject: 'Message',
    },
    {
      action: 'markAsRead',
      subject: 'Message',
    },
    {
      action: 'markAsReadBulk',
      subject: 'Message',
    },
    {
      action: 'archive',
      subject: 'Message',
    },
    {
      action: 'delete',
      subject: 'Message',
    },
    {
      action: 'select',
      subject: 'Message',
    },
    {
      action: 'see',
      subject: 'Bounced rate',
    },
    CAN_SEE_ROTTING,
  ],
  [CLIENT_GROUP]: [
    {
      action: 'see',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Campaign Selector',
    },
    {
      action: 'filterBy',
      subject: 'Campaign',
    },
    {
      action: 'see',
      subject: 'Sequence',
    },
  ],
};

export const PERMISSIONS = {
  CAN_SEE_INBOX: 'CAN_SEE_INBOX',
  CAN_SEE_OPPORTUNITIES: 'view_opportunity',
  CAN_ADD_OPPORTUNITIES: 'add_opportunity',
  CAN_UPDATE_OPPORTUNITIES: 'change_opportunity',
  CAN_DELETE_OPPORTUNITIES: 'delete_opportunity',
  CAN_SEE_SUBSCRIPTIONS: 'view_subscription',
};

export const PERMISSIONS_ACTIONS = {
  view_opportunity: { action: 'see', subject: 'Opportunity' },
  add_opportunity: { action: 'add', subject: 'Opportunity' },
  change_opportunity: { action: 'edit', subject: 'Opportunity' },
  delete_opportunity: { action: 'delete', subject: 'Opportunity' },
};

export const ORGANIZATION_PERMISSIONS = {
  CAN_SEE_SUBSCRIPTIONS: {
    action: 'see',
    subject: 'Subscription',
  },
};

export const PRVOLT_ORGANIZATION_PERMISSIONS = {
  [CLIENT_GROUP]: [
    { action: 'see', subject: 'Billing' },
  ],
};

// sequence modal
export const REPLY_STATUSES = [
  { label: 'Interested', value: 'interested' },
  { label: 'Not interested', value: 'not_interested' },
  { label: 'Not now', value: 'not_now' },
  { label: 'Do not contact', value: 'do_not_contact' },
  { label: 'Sponsorship', value: 'sponsorship' },
  { label: 'Unsubscribed', value: 'unsubscribed' },
];

export const INCLUDE_EXCLUDE_STATUSES = [
  { label: 'Interested', value: 'interested' },
  { label: 'Not interested', value: 'not_interested' },
  { label: 'Not now', value: 'not_now' },
  { label: 'Sponsorship', value: 'sponsorship' },
  { label: 'Unsubscribed', value: 'unsubscribed' },
];

export const OPPORTUNITY_STAGES = [
  { label: 'Active', value: 'active' },
  { label: 'Confirmed', value: 'confirmed' },
  { label: 'Published', value: 'published' },
  { label: 'Not now', value: 'not_now' },
  { label: 'Closed', value: 'closed' },
];

export const NOTIFICATION_NODE_STYLE = { top: 0, left: 'calc(100vw - 100%)' };

export const WHITE_GLOVE_ID = 7;
export const BUSINESS_SUBSCRIPTION_TYPE_PK = 3;

export const MIN_DESKTOP_WIDTH = 576;
export const MAX_SMALL_SIZE = 704;
export const MAX_MEDIUM_SIZE = 1024;
export const MAX_LARGE_SIZE = 1200;
export const MAX_EXTRA_LARGE_SIZE = 1600;

export const CAMPAIGN_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'completed', label: 'Completed' },
  { value: 'not_completed', label: 'Not completed' },
  { value: 'errored', label: 'Errored' },
];

export const STATUS_FILTER_PARAMS = {
  true: 'Active',
  false: 'Not Active',
};
export const NULL_STATUS = 'Statuses';

export const MAX_FILE_SIZE = 5592431; // Bytes

export const GOOGLE_APP_VERIFICATION_DOC =
    'https://docs.google.com/document/d/1SWWuifTkfeWKSDBZ9LmzxBPSzpFsQQHS066BtvUDLKg/edit?usp=sharing';

export const DEFAULT_COUNTRY = 'US';

export const countryList = [
  {
    label: 'AL',
    value: 'AL',
    code: '355',
  },
  {
    label: 'AX',
    value: 'AX',
    code: '358-18',
  },
  {
    label: 'DZ',
    value: 'DZ',
    code: '213',
  },
  {
    label: 'AS',
    value: 'AS',
    code: '1-684',
  },
  {
    label: 'AD',
    value: 'AD',
    code: '376',
  },
  {
    label: 'AO',
    value: 'AO',
    code: '244',
  },
  {
    label: 'AI',
    value: 'AI',
    code: '1-264',
  },
  {
    label: 'AQ',
    value: 'AQ',
    code: '672',
  },
  {
    label: 'AG',
    value: 'AG',
    code: '1-268',
  },
  {
    label: 'AR',
    value: 'AR',
    code: '54',
  },
  {
    label: 'AM',
    value: 'AM',
    code: '374',
  },
  {
    label: 'AW',
    value: 'AW',
    code: '297',
  },
  {
    label: 'AU',
    value: 'AU',
    code: '61',
  },
  {
    label: 'AT',
    value: 'AT',
    code: '43',
  },
  {
    label: 'AZ',
    value: 'AZ',
    code: '994',
  },
  {
    label: 'BS',
    value: 'BS',
    code: '1-242',
  },
  {
    label: 'BH',
    value: 'BH',
    code: '973',
  },
  {
    label: 'BD',
    value: 'BD',
    code: '880',
  },
  {
    label: 'BB',
    value: 'BB',
    code: '1-246',
  },
  {
    label: 'BY',
    value: 'BY',
    code: '375',
  },
  {
    label: 'BE',
    value: 'BE',
    code: '32',
  },
  {
    label: 'BZ',
    value: 'BZ',
    code: '501',
  },
  {
    label: 'BJ',
    value: 'BJ',
    code: '229',
  },
  {
    label: 'BM',
    value: 'BM',
    code: '1-441',
  },
  {
    label: 'BT',
    value: 'BT',
    code: '975',
  },
  {
    label: 'BO',
    value: 'BO',
    code: '591',
  },
  {
    label: 'BQ',
    value: 'BQ',
    code: '599',
  },
  {
    label: 'BA',
    value: 'BA',
    code: '387',
  },
  {
    label: 'BW',
    value: 'BW',
    code: '267',
  },
  {
    label: 'BR',
    value: 'BR',
    code: '55',
  },
  {
    label: 'IO',
    value: 'IO',
    code: '246',
  },
  {
    label: 'BN',
    value: 'BN',
    code: '673',
  },
  {
    label: 'BG',
    value: 'BG',
    code: '359',
  },
  {
    label: 'BF',
    value: 'BF',
    code: '226',
  },
  {
    label: 'BI',
    value: 'BI',
    code: '257',
  },
  {
    label: 'CV',
    value: 'CV',
    code: '238',
  },
  {
    label: 'KH',
    value: 'KH',
    code: '855',
  },
  {
    label: 'CM',
    value: 'CM',
    code: '237',
  },
  {
    label: 'CA',
    value: 'CA',
    code: '1',
  },
  {
    label: 'KY',
    value: 'KY',
    code: '1-345',
  },
  {
    label: 'CF',
    value: 'CF',
    code: '236',
  },
  {
    label: 'TD',
    value: 'TD',
    code: '235',
  },
  {
    label: 'CL',
    value: 'CL',
    code: '56',
  },
  {
    label: 'CN',
    value: 'CN',
    code: '86',
  },
  {
    label: 'CX',
    value: 'CX',
    code: '61',
  },
  {
    label: 'CC',
    value: 'CC',
    code: '61',
  },
  {
    label: 'CO',
    value: 'CO',
    code: '57',
  },
  {
    label: 'KM',
    value: 'KM',
    code: '269',
  },
  {
    label: 'CD',
    value: 'CD',
    code: '243',
  },
  {
    label: 'CG',
    value: 'CG',
    code: '242',
  },
  {
    label: 'CK',
    value: 'CK',
    code: '682',
  },
  {
    label: 'CR',
    value: 'CR',
    code: '506',
  },
  {
    label: 'HR',
    value: 'HR',
    code: '385',
  },
  {
    label: 'CU',
    value: 'CU',
    code: '53',
  },
  {
    label: 'CW',
    value: 'CW',
    code: '599',
  },
  {
    label: 'CY',
    value: 'CY',
    code: '357',
  },
  {
    label: 'CZ',
    value: 'CZ',
    code: '420',
  },
  {
    label: 'CI',
    value: 'CI',
    code: '225',
  },
  {
    label: 'DK',
    value: 'DK',
    code: '45',
  },
  {
    label: 'DJ',
    value: 'DJ',
    code: '253',
  },
  {
    label: 'DM',
    value: 'DM',
    code: '1-767',
  },
  {
    label: 'DO',
    value: 'DO',
    code: '1-809',
  },
  {
    label: 'EC',
    value: 'EC',
    code: '593',
  },
  {
    label: 'EG',
    value: 'EG',
    code: '20',
  },
  {
    label: 'SV',
    value: 'SV',
    code: '503',
  },
  {
    label: 'GQ',
    value: 'GQ',
    code: '240',
  },
  {
    label: 'ER',
    value: 'ER',
    code: '291',
  },
  {
    label: 'EE',
    value: 'EE',
    code: '372',
  },
  {
    label: 'SZ',
    value: 'SZ',
    code: '268',
  },
  {
    label: 'ET',
    value: 'ET',
    code: '251',
  },
  {
    label: 'FK',
    value: 'FK',
    code: '500',
  },
  {
    label: 'FO',
    value: 'FO',
    code: '298',
  },
  {
    label: 'FJ',
    value: 'FJ',
    code: '679',
  },
  {
    label: 'FI',
    value: 'FI',
    code: '358',
  },
  {
    label: 'FR',
    value: 'FR',
    code: '33',
  },
  {
    label: 'GF',
    value: 'GF',
    code: '594',
  },
  {
    label: 'PF',
    value: 'PF',
    code: '689',
  },
  {
    label: 'GA',
    value: 'GA',
    code: '241',
  },
  {
    label: 'GM',
    value: 'GM',
    code: '220',
  },
  {
    label: 'GE',
    value: 'GE',
    code: '995',
  },
  {
    label: 'DE',
    value: 'DE',
    code: '49',
  },
  {
    label: 'GH',
    value: 'GH',
    code: '233',
  },
  {
    label: 'GI',
    value: 'GI',
    code: '350',
  },
  {
    label: 'GR',
    value: 'GR',
    code: '30',
  },
  {
    label: 'GL',
    value: 'GL',
    code: '299',
  },
  {
    label: 'GD',
    value: 'GD',
    code: '1-473',
  },
  {
    label: 'GP',
    value: 'GP',
    code: '590',
  },
  {
    label: 'GU',
    value: 'GU',
    code: '1-671',
  },
  {
    label: 'GT',
    value: 'GT',
    code: '502',
  },
  {
    label: 'GG',
    value: 'GG',
    code: '44-1481',
  },
  {
    label: 'GN',
    value: 'GN',
    code: '224',
  },
  {
    label: 'GW',
    value: 'GW',
    code: '245',
  },
  {
    label: 'GY',
    value: 'GY',
    code: '592',
  },
  {
    label: 'HT',
    value: 'HT',
    code: '509',
  },
  {
    label: 'HM',
    value: 'HM',
    code: ' ',
  },
  {
    label: 'VA',
    value: 'VA',
    code: '379',
  },
  {
    label: 'HN',
    value: 'HN',
    code: '504',
  },
  {
    label: 'HK',
    value: 'HK',
    code: '852',
  },
  {
    label: 'HU',
    value: 'HU',
    code: '36',
  },
  {
    label: 'IS',
    value: 'IS',
    code: '354',
  },
  {
    label: 'IN',
    value: 'IN',
    code: '91',
  },
  {
    label: 'ID',
    value: 'ID',
    code: '62',
  },
  {
    label: 'IR',
    value: 'IR',
    code: '98',
  },
  {
    label: 'IQ',
    value: 'IQ',
    code: '964',
  },
  {
    label: 'IE',
    value: 'IE',
    code: '353',
  },
  {
    label: 'IM',
    value: 'IM',
    code: '44-1624',
  },
  {
    label: 'IL',
    value: 'IL',
    code: '972',
  },
  {
    label: 'IT',
    value: 'IT',
    code: '39',
  },
  {
    label: 'JM',
    value: 'JM',
    code: '1-876',
  },
  {
    label: 'JP',
    value: 'JP',
    code: '81',
  },
  {
    label: 'JE',
    value: 'JE',
    code: '44-1534',
  },
  {
    label: 'JO',
    value: 'JO',
    code: '962',
  },
  {
    label: 'KZ',
    value: 'KZ',
    code: '7',
  },
  {
    label: 'KE',
    value: 'KE',
    code: '254',
  },
  {
    label: 'KI',
    value: 'KI',
    code: '686',
  },
  {
    label: 'KP',
    value: 'KP',
    code: '850',
  },
  {
    label: 'KR',
    value: 'KR',
    code: '82',
  },
  {
    label: 'KW',
    value: 'KW',
    code: '965',
  },
  {
    label: 'KG',
    value: 'KG',
    code: '996',
  },
  {
    label: 'LA',
    value: 'LA',
    code: '856',
  },
  {
    label: 'LV',
    value: 'LV',
    code: '371',
  },
  {
    label: 'LB',
    value: 'LB',
    code: '961',
  },
  {
    label: 'LS',
    value: 'LS',
    code: '266',
  },
  {
    label: 'LR',
    value: 'LR',
    code: '231',
  },
  {
    label: 'LY',
    value: 'LY',
    code: '218',
  },
  {
    label: 'LI',
    value: 'LI',
    code: '423',
  },
  {
    label: 'LT',
    value: 'LT',
    code: '370',
  },
  {
    label: 'LU',
    value: 'LU',
    code: '352',
  },
  {
    label: 'MO',
    value: 'MO',
    code: '853',
  },
  {
    label: 'MG',
    value: 'MG',
    code: '261',
  },
  {
    label: 'MW',
    value: 'MW',
    code: '265',
  },
  {
    label: 'MY',
    value: 'MY',
    code: '60',
  },
  {
    label: 'MV',
    value: 'MV',
    code: '960',
  },
  {
    label: 'ML',
    value: 'ML',
    code: '223',
  },
  {
    label: 'MT',
    value: 'MT',
    code: '356',
  },
  {
    label: 'MH',
    value: 'MH',
    code: '692',
  },
  {
    label: 'MQ',
    value: 'MQ',
    code: '596',
  },
  {
    label: 'MR',
    value: 'MR',
    code: '222',
  },
  {
    label: 'MU',
    value: 'MU',
    code: '230',
  },
  {
    label: 'YT',
    value: 'YT',
    code: '262',
  },
  {
    label: 'MX',
    value: 'MX',
    code: '52',
  },
  {
    label: 'FM',
    value: 'FM',
    code: '691',
  },
  {
    label: 'MD',
    value: 'MD',
    code: '373',
  },
  {
    label: 'MC',
    value: 'MC',
    code: '377',
  },
  {
    label: 'MN',
    value: 'MN',
    code: '976',
  },
  {
    label: 'ME',
    value: 'ME',
    code: '382',
  },
  {
    label: 'MS',
    value: 'MS',
    code: '1-664',
  },
  {
    label: 'MA',
    value: 'MA',
    code: '212',
  },
  {
    label: 'MZ',
    value: 'MZ',
    code: '258',
  },
  {
    label: 'MM',
    value: 'MM',
    code: '95',
  },
  {
    label: 'NA',
    value: 'NA',
    code: '264',
  },
  {
    label: 'NR',
    value: 'NR',
    code: '674',
  },
  {
    label: 'NP',
    value: 'NP',
    code: '977',
  },
  {
    label: 'NL',
    value: 'NL',
    code: '31',
  },
  {
    label: 'NC',
    value: 'NC',
    code: '687',
  },
  {
    label: 'NZ',
    value: 'NZ',
    code: '64',
  },
  {
    label: 'NI',
    value: 'NI',
    code: '505',
  },
  {
    label: 'NE',
    value: 'NE',
    code: '227',
  },
  {
    label: 'NG',
    value: 'NG',
    code: '234',
  },
  {
    label: 'NU',
    value: 'NU',
    code: '683',
  },
  {
    label: 'NF',
    value: 'NF',
    code: '672',
  },
  {
    label: 'MP',
    value: 'MP',
    code: '1-670',
  },
  {
    label: 'NO',
    value: 'NO',
    code: '47',
  },
  {
    label: 'OM',
    value: 'OM',
    code: '968',
  },
  {
    label: 'PK',
    value: 'PK',
    code: '92',
  },
  {
    label: 'PW',
    value: 'PW',
    code: '680',
  },
  {
    label: 'PS',
    value: 'PS',
    code: '970',
  },
  {
    label: 'PA',
    value: 'PA',
    code: '507',
  },
  {
    label: 'PG',
    value: 'PG',
    code: '675',
  },
  {
    label: 'PY',
    value: 'PY',
    code: '595',
  },
  {
    label: 'PE',
    value: 'PE',
    code: '51',
  },
  {
    label: 'PH',
    value: 'PH',
    code: '63',
  },
  {
    label: 'PN',
    value: 'PN',
    code: '870',
  },
  {
    label: 'PL',
    value: 'PL',
    code: '48',
  },
  {
    label: 'PT',
    value: 'PT',
    code: '351',
  },
  {
    label: 'PR',
    value: 'PR',
    code: '1-787',
  },
  {
    label: 'QA',
    value: 'QA',
    code: '974',
  },
  {
    label: 'MK',
    value: 'MK',
    code: '389',
  },
  {
    label: 'RO',
    value: 'RO',
    code: '40',
  },
  {
    label: 'RU',
    value: 'RU',
    code: '7',
  },
  {
    label: 'RW',
    value: 'RW',
    code: '250',
  },
  {
    label: 'RE',
    value: 'RE',
    code: '262',
  },
  {
    label: 'BL',
    value: 'BL',
    code: '590',
  },
  {
    label: 'SH',
    value: 'SH',
    code: '290',
  },
  {
    label: 'KN',
    value: 'KN',
    code: '1-869',
  },
  {
    label: 'LC',
    value: 'LC',
    code: '1-758',
  },
  {
    label: 'MF',
    value: 'MF',
    code: '590',
  },
  {
    label: 'PM',
    value: 'PM',
    code: '508',
  },
  {
    label: 'VC',
    value: 'VC',
    code: '1-784',
  },
  {
    label: 'WS',
    value: 'WS',
    code: '685',
  },
  {
    label: 'SM',
    value: 'SM',
    code: '378',
  },
  {
    label: 'ST',
    value: 'ST',
    code: '239',
  },
  {
    label: 'SA',
    value: 'SA',
    code: '966',
  },
  {
    label: 'SN',
    value: 'SN',
    code: '221',
  },
  {
    label: 'RS',
    value: 'RS',
    code: '381',
  },
  {
    label: 'SC',
    value: 'SC',
    code: '248',
  },
  {
    label: 'SL',
    value: 'SL',
    code: '232',
  },
  {
    label: 'SG',
    value: 'SG',
    code: '65',
  },
  {
    label: 'SX',
    value: 'SX',
    code: '599',
  },
  {
    label: 'SK',
    value: 'SK',
    code: '421',
  },
  {
    label: 'SI',
    value: 'SI',
    code: '386',
  },
  {
    label: 'SB',
    value: 'SB',
    code: '677',
  },
  {
    label: 'SO',
    value: 'SO',
    code: '252',
  },
  {
    label: 'ZA',
    value: 'ZA',
    code: '27',
  },
  {
    label: 'GS',
    value: 'GS',
    code: '500',
  },
  {
    label: 'SS',
    value: 'SS',
    code: '211',
  },
  {
    label: 'ES',
    value: 'ES',
    code: '34',
  },
  {
    label: 'LK',
    value: 'LK',
    code: '94',
  },
  {
    label: 'SD',
    value: 'SD',
    code: '249',
  },
  {
    label: 'SR',
    value: 'SR',
    code: '597',
  },
  {
    label: 'SJ',
    value: 'SJ',
    code: '47',
  },
  {
    label: 'SE',
    value: 'SE',
    code: '46',
  },
  {
    label: 'CH',
    value: 'CH',
    code: '41',
  },
  {
    label: 'SY',
    value: 'SY',
    code: '963',
  },
  {
    label: 'TW',
    value: 'TW',
    code: '886',
  },
  {
    label: 'TJ',
    value: 'TJ',
    code: '992',
  },
  {
    label: 'TZ',
    value: 'TZ',
    code: '255',
  },
  {
    label: 'TH',
    value: 'TH',
    code: '66',
  },
  {
    label: 'TL',
    value: 'TL',
    code: '670',
  },
  {
    label: 'TG',
    value: 'TG',
    code: '228',
  },
  {
    label: 'TK',
    value: 'TK',
    code: '690',
  },
  {
    label: 'TO',
    value: 'TO',
    code: '676',
  },
  {
    label: 'TT',
    value: 'TT',
    code: '1-868',
  },
  {
    label: 'TN',
    value: 'TN',
    code: '216',
  },
  {
    label: 'TR',
    value: 'TR',
    code: '90',
  },
  {
    label: 'TM',
    value: 'TM',
    code: '993',
  },
  {
    label: 'TC',
    value: 'TC',
    code: '1-649',
  },
  {
    label: 'TV',
    value: 'TV',
    code: '688',
  },
  {
    label: 'UG',
    value: 'UG',
    code: '256',
  },
  {
    label: 'UA',
    value: 'UA',
    code: '380',
  },
  {
    label: 'AE',
    value: 'AE',
    code: '971',
  },
  {
    label: 'GB',
    value: 'GB',
    code: '44',
  },
  {
    label: 'UM',
    value: 'UM',
    code: '1',
  },
  {
    label: 'US',
    value: 'US',
    code: '1',
  },
  {
    label: 'UY',
    value: 'UY',
    code: '598',
  },
  {
    label: 'UZ',
    value: 'UZ',
    code: '998',
  },
  {
    label: 'VU',
    value: 'VU',
    code: '678',
  },
  {
    label: 'VE',
    value: 'VE',
    code: '58',
  },
  {
    label: 'VN',
    value: 'VN',
    code: '84',
  },
  {
    label: 'VG',
    value: 'VG',
    code: '1-284',
  },
  {
    label: 'VI',
    value: 'VI',
    code: '1-340',
  },
  {
    label: 'WF',
    value: 'WF',
    code: '681',
  },
  {
    label: 'EH',
    value: 'EH',
    code: '212',
  },
  {
    label: 'YE',
    value: 'YE',
    code: '967',
  },
  {
    label: 'ZM',
    value: 'ZM',
    code: '260',
  },
  {
    label: 'ZW',
    value: 'ZW',
    code: '263',
  },
].map(el => ({ ...el, label: `${el.label}(+${el.code})`, code: undefined }))
  // eslint-disable-next-line no-nested-ternary
  .sort((a, b) => ((a.label > b.label) ? 1 : (b.label > a.label) ? -1 : 0));
